import { CalendarOptions } from '@fullcalendar/core';

export const Calendar = {
    defaults: <CalendarOptions>{
        headerToolbar: {
            left: '',
            center: 'title',
            right: '',
        },
        allDaySlot: false,
        editable: true,
        eventColor: '#0091EA',
        eventTextColor: '#FFFFFF',
        lazyFetching: false,
        locale: 'sv',
        selectable: true,
        slotEventOverlap: false,
        unselectAuto: false,
        weekNumbers: true,
    },
    query: {
        url: 'posts',
    },
};

// export const Calendar = {
//     defaults: {
//         header: {
//             left: '',
//             center: 'title',
//             right: '',
//         },
//         allDaySlot: false,
//         columnFormat: 'ddd D/M',
//         defaultView: 'agendaWeek',
//         editable: true,
//         eventColor: '#0091EA',
//         eventLimit: true,
//         eventTextColor: '#FFFFFF',
//         lazyFetching: false,
//         locale: 'sv',
//         maxTime: '23:59:59',
//         minTime: '06:00:00',
//         scrollTime: '10:00:00',
//         selectable: true,
//         selectHelper: true,
//         slotDuration: '00:10:00',
//         slotEventOverlap: false,
//         timezone: 'local',
//         unselectAuto: false,
//         weekNumbers: true,
//         weekNumberTitle: 'v ',
//     },
//     query: {
//         url: 'posts',
//     },
// };
